import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

export function useAllSearchParams<T>() {
  const location = useLocation();

  const params = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);

    const params: T = {} as T;
    searchParams.forEach((value, key) => {
      params[key as keyof T] = value as any;
    });

    return params;
  }, [location.search]);

  return params;
}

export function useSearchParams() {
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  return searchParams;
}
